import { Component, Input } from '@angular/core';
import { InstagramElementPreviewFragment } from '@/core/graphql/graphql';

@Component({
  selector: 'cosmos-instagram-element-preview',
  templateUrl: './instagram-element-preview.component.html',
  styleUrls: ['./instagram-element-preview.component.scss'],
})
export class InstagramElementPreviewComponent {
  @Input() public element: InstagramElementPreviewFragment;
}
